// src/components/common/SupplierSelect.jsx

import { useEffect, useRef, useState } from "react";
import supplierAPI from "../../../../api/inventory/supplierApi";
import { useDebounce } from "../../../../hooks/useDebounce";

export default function SupplierSelect({ name, value, onChange }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);

  const debounced = useDebounce(query, 500);

  const containerRef = useRef(null);

  // Fetch Suppliers
  const fetchSupplier = async () => {
    try {
      const params = {
        q: debounced,
      };

      const res = await supplierAPI.search(params);

      if (res.code === 200) {
        setResults(res.data || []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (open) {
      fetchSupplier();
    }
  }, [debounced, open]);

  // Close dropdown outside click
  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  // Select Supplier
  const handleSelect = (supplier) => {
    setQuery("");
    setOpen(false);

    onChange({
      target: {
        name,
        value: supplier,
      },
    });
  };

  // Clear Selected Supplier
  const clear = () => {
    onChange({
      target: {
        name,
        value: null,
      },
    });

    setQuery("");
    setOpen(false);
  };

  // Selected View
  if (value) {
    return (
      <div className="d-flex align-items-center justify-content-between border rounded p-2">
        <div>
          <div className="fw-semibold">{value.name}</div>

          <div className="small text-muted">
            {value.gstin && <>GSTIN: {value.gstin} · </>}
            {value.paymentTermDays || 0}d payment terms
          </div>
        </div>

        <button
          type="button"
          className="btn btn-sm btn-link text-danger"
          onClick={clear}
        >
          <i className="ti ti-x" />
        </button>
      </div>
    );
  }

  return (
    <div className="position-relative" ref={containerRef}>
      <input
        type="text"
        className="form-control"
        placeholder="Search supplier..."
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
      />

      {open && (
        <ul
          className="list-group position-absolute w-100 shadow"
          style={{
            zIndex: 1050,
            top: "100%",
            maxHeight: 280,
            overflowY: "auto",
          }}
        >
          {results.length > 0 ? (
            results.map((s) => (
              <li
                key={s.id}
                className="list-group-item list-group-item-action"
                style={{
                  cursor: "pointer",
                }}
                onClick={() => handleSelect(s)}
              >
                <div className="fw-semibold">{s.name}</div>
                <div className="small text-muted">
                  {s.city && `${s.city}, ${s.state}`}
                  {s.gstin && ` · ${s.gstin}`}
                </div>
              </li>
            ))
          ) : (
            <li className="list-group-item text-muted small text-center">
              No suppliers found
            </li>
          )}
        </ul>
      )}
    </div>
  );
}
